import React, {Component} from "react"
import {withTranslate} from "react-redux-multilingual";

class Accordion extends Component {
    render() {
        return (
            <div id="accordion">
                <div className="card shadow-4d">
                    <div className="card-header">
                        {this.props.collapse !== false ?
                            <a className="card-link"
                               data-toggle="collapse" href={"#" + this.props.box}
                               aria-expanded="true"
                               aria-controls="menuone">
                                {this.props.translate ? this.props.translate(this.props.box) : ""}

                                <span
                                    className="collapsed"><i className="fas fa-chevron-down"></i></span>
                                <span
                                    className="expanded"><i className="fas fa-chevron-up"></i></span>
                            </a>

                        : null }
                    </div>
                    <div id={this.props.box} className="collapse show">
                        <div className="card-body">
                            {this.props.children}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslate(Accordion)